import { Button } from "@/components/ui/button";

/** Nút tải thêm dùng chung, kèm số đã hiển thị trên tổng. */
export function LoadMore({
    shown,
    total,
    hasMore,
    loading,
    onLoadMore,
    unit = "mục",
}: {
    shown: number;
    total: number;
    hasMore: boolean;
    loading: boolean;
    onLoadMore: () => void;
    unit?: string;
}) {
    if (total === 0) return null;

    return (
        <div className="flex items-center justify-between gap-3 pt-1 text-xs text-ink-muted">
            <span>
                Hiển thị {shown} / {total} {unit}
            </span>
            {hasMore && (
                <Button variant="secondary" size="sm" loading={loading} onClick={onLoadMore}>
                    Tải thêm
                </Button>
            )}
        </div>
    );
}
